import { Chip } from "@mui/material";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import { CounterpartyRoleTypeEnum } from "../counterpartyApi";
import { Localized } from "@fluent/react";

type Props = {
    role: CounterpartyRoleTypeEnum;
};

const getRoleColor = (role: CounterpartyRoleTypeEnum) => {
    switch (role) {
        case "CUSTOMER":
            return "#1976d2"; // blue
        case "SUPPLIER":
            return "#2e7d32"; // green
        case "PARTNER":
            return "#6a1b9a"; // purple
        case "REPRESENTATIVE":
            return "#ed6c02"; // orange
        case "SUBCONTRACTOR":
            return "#00838f"; // teal
        case "OTHER":
        default:
            return "#616161"; // grey
    }
};

export const CounterpartyRoleChip = ({ role }: Props) => {
    const color = getRoleColor(role);

    return (
        <Chip
            size="small"
            variant="outlined"
            icon={<WorkOutlineOutlinedIcon sx={{ color }} />}
            label={
                <Localized id={`counterparties-role-${role}`}>
                    <span>{role}</span>
                </Localized>
            }
            sx={{
                borderColor: color,
                color: color,
                fontWeight: 500,
            }}
        />
    );
};